import AtlasMark from '@icon/atlas-mark.svg';
import type { JSX } from 'solid-js';

/** Temporary monogram; inherits the existing surface's foreground color. */
export function AtlasMarkIcon(props: {
  style?: JSX.CSSProperties;
  class?: string;
}) {
  return (
    <AtlasMark aria-hidden="true" class={props.class} style={props.style} />
  );
}
